import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { getThreadDetail } from '../../../modules/apis/student/conversation'
import { useCurrentUser } from '../../../modules/context/UserContext'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { getAITutorTranslation } from '../../../modules/utils'
import { THREAD_STATUS } from '../../../modules/vars'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'
import ConversationHeader from './ai_tutor_roleplay_activity/ConversationHeader'
import ConversationProgress from './ai_tutor_roleplay_activity/ConversationProgress'

const ConversationMainBody = dynamic(() => import('../../new-portal/ai-tutor/roleplay/index'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const ConversationMainActivity: ActivityComponentType = () => {
  const router = useAppRouter()
  const threadId = router.query?.threadId
  const roleplayId = router.query?.roleplayId

  const { currentUser } = useCurrentUser()

  const [thread, setThread] = useState(null)
  const [showCompleteModal, setShowCompleteModal] = useState(false)
  const [isConversationQualified, setIsConversationQualified] = useState(false)
  const [triggerSummary, setTriggerSummary] = useState(false)
  const [turnCnt, setTurnCnt] = useState(0)
  const [wordCnt, setWordCnt] = useState(0)
  const [isSessionDone, setIsSessionDone] = useState(false)
  const getFullUrl = useReturnFullUrl()
  const { locale } = useTranslation()

  useEffect(() => {
    if (!threadId) return

    getThreadDetail(threadId).then((data) => {
      setThread(data)
    })
  }, [threadId])

  const onClickThreadSummary = () => {
    setShowCompleteModal(false)

    router.push(urls.webview.aiTutor.roleplayDone(threadId, roleplayId), {
      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
      appSendData: {
        url: getFullUrl(urls.webview.aiTutor.roleplayDone(threadId, roleplayId)),
      },
    })
  }

  //▶️ This function is for custom made roleplay.
  const getTitle = () => {
    return getAITutorTranslation(thread?.roleplay_title, locale)
  }

  // return <>roleplay</>

  if (!currentUser) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <LoadingSpinner lg show primary />
      </div>
    )
  }

  return (
    <WebviewStackContainer
      height="52px"
      border={false}
      title={
        <div className="w-full flex flex-col">
          <ConversationHeader
            thread={thread}
            title={getTitle()}
            isConversationDone={thread?.status !== THREAD_STATUS.IN_PROGRESS || isSessionDone}
            isConversationQualified={isConversationQualified}
            onClickThreadSummary={onClickThreadSummary}
            showCompleteModal={showCompleteModal}
            setShowCompleteModal={setShowCompleteModal}
          />
        </div>
      }
    >
      <ConversationProgress
        turnCnt={turnCnt}
        wordCnt={wordCnt}
        isConversationQualified={isConversationQualified}
        minimumWord={thread?.minimum_word}
      />

      <ConversationMainBody
        thread={thread}
        threadId={threadId}
        setTurnCnt={setTurnCnt}
        setWordCnt={setWordCnt}
        setIsConversationQualified={setIsConversationQualified}
        triggerSummary={triggerSummary}
        setTriggerSummary={setTriggerSummary}
        isSessionDone={isSessionDone}
        setIsSessionDone={setIsSessionDone}
      />
    </WebviewStackContainer>
  )
}

export default ConversationMainActivity
